<div id="modal-content">
  <div id="modal-content__header" nz-row nzType="flex" nzJustify="center" nzAlign="middle">
    <p [innerHTML]="'modals.projection-chart-calculation.desc' | translate"></p>
  </div>
  <ng-container *ngFor="let block of blocks">
    <div class="legend">
      <div class="legend-header" nz-row nzType="flex" nzAlign="middle" nzJustify="start">
        <span class="legend-header__icon" [ngClass]="block.className"></span>
        <span class="legend-header__title">{{ block.titleKey | translate }}</span>
        <div class="legend-content" [innerHTML]="block.descriptionKey | translate"></div>
      </div>
      <ng-container *ngIf="block.disclaimerKey">
        <div class="legend-footer" [innerHTML]="block.disclaimerKey | translate"></div>
      </ng-container>
    </div>
  </ng-container>
</div>

<div id="modal-footer">
  <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
    <p [innerHTML]="'modals.projection-chart-calculation.disclaimer' | translate"></p>
  </div>
</div>
